import { Components } from "appworks/components/components";
import { FadeIn } from "appworks/graphics/animation/base-animations";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { reject } from "appworks/utils/collection-utils";
import { Contract } from "appworks/utils/contracts/contract";
import { Timer } from "appworks/utils/timer";
import { TGRShouldCelebrateWins } from "commands/tgr-should-celebrate-wins";
import { gameLayers } from "game-layers";
import { AbstractMatrixComponent, DimType } from "slotworks/components/matrix/abstract-matrix-component";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { LoopWins } from "slotworks/state-machine/standard/states/loop-wins";

const LineWinRows = {
    1: 2, 2: 3, 3: 2, 4: 3, 5: 4, 6: 2, 7: 3, 8: 1, 9: 3, 10: 1,
    11: 2, 12: 3, 13: 1, 14: 2, 15: 3, 16: 2, 17: 3, 18: 2, 19: 3, 20: 2,
    21: 3, 22: 1, 23: 2, 24: 3, 25: 1
};

export class TGRLoopwins extends LoopWins {

    public onExit(): void {
        Components.get(MatrixComponent).resetSymbols();
        gameLayers.SymbolAnimations.clear();
        super.onExit();
    }

    protected showWin(win: SymbolWinResult): Contract<void> {
        const gameplay = gameState.getCurrentGame();
        const record = gameplay.getCurrentRecord() as SpinRecord;

        const winningSymbols = Components.get(AbstractMatrixComponent).getSymbolsFromPositions(win.positions);
        if (!winningSymbols.length || !TGRShouldCelebrateWins(record)) {
            return Contract.getTimeoutContract(1000);
        }

        const currentCycle = this.recordCycleCount.get(record);

        Components.get(AbstractMatrixComponent).playSymbolSound(win.symbolType, win.matches.toString(), currentCycle.toString());

        const remainingSymbols = reject(Components.get(AbstractMatrixComponent).getBaseGridSymbols(), winningSymbols);

        if (this.config.dimSymbols) {
            const hiddenSymbols = Components.get(AbstractMatrixComponent).getHiddenSymbols();
            Components.get(AbstractMatrixComponent).dimSymbols(remainingSymbols.concat(hiddenSymbols), DimType.Cycle, win).execute();
        }

        const contract = this.cancelGroup.parallel([
            () => Components.get(AbstractMatrixComponent).showWinningSymbols(winningSymbols, win, currentCycle > 0),
            () => Contract.wrap(() => {
                if (win instanceof LineResult && win.line) {
                    gameLayers.CelebrationContent.setScene(`line_win_row_${LineWinRows[win.line]}`).execute();
                    const value = gameLayers.CelebrationContent.getText("value");
                    value.text = Services.currency.format(win.cashWon);
                    FadeIn(value, 250).execute();
                }
            }),
            () => Contract.getTimeoutContract(this.config.minWinTime)
        ]);

        if (this.config.maxWinTime < Infinity) {
            Timer.setTimeout(() => {
                contract.forceResolve();
            }, this.config.maxWinTime);
        }

        return contract;
    }
}
